import { createContext, createElement, useContext } from 'react';

/* One switch that takes the Buffy character off a page (schools page,
   2026-10-01: Sandy wants it "a little more professional"). Every component
   that draws Buffy is wrapped with withBuffyGate, so a page that provides
   BuffyOffContext = true renders none of them (no canvas, no painter, no
   animation clock). Pages that do not provide it are unchanged. The name
   "Buffy" for the AI assistant stays in words; only the art goes. */
export const BuffyOffContext = createContext(false);

export function withBuffyGate(Component) {
  function BuffyGate(props) {
    const off = useContext(BuffyOffContext);
    return off ? null : createElement(Component, props);
  }
  BuffyGate.displayName = `BuffyGate(${Component.displayName || Component.name || 'Buffy'})`;
  return BuffyGate;
}
